import { observeElementInView } from "../vendor/inview-observer";
// eslint-disable-next-line import/no-unresolved -- swiper/bundle is a valid package export; resolver doesn't follow package.json "exports"
import Swiper from "swiper/bundle";

const initCaseStudies = (section) => {
	if (section.dataset.initialized === "true") {
		return;
	}

	const root = section.querySelector(".case-studies__swiper");
	const pager = section.querySelector(".case-studies__pager");

	if (!root) {
		return;
	}

	const slides = root.querySelectorAll(".swiper-slide");

	if (!slides.length) {
		return;
	}

	new Swiper(root, {
		slidesPerView: 1,
		spaceBetween: 16,
		speed: 600,
		watchOverflow: true,
		grabCursor: slides.length > 1,
		pagination:
			pager && slides.length > 1
				? {
						el: pager,
						clickable: true,
					}
				: undefined,
		breakpoints: {
			768: {
				slidesPerView: "auto",
				spaceBetween: 32,
			},
			992: {
				slidesPerView: "auto",
				spaceBetween: 40,
			},
			1600: {
				slidesPerView: "auto",
				spaceBetween: 55,
			},
		},
	});

	section.dataset.initialized = "true";
};

const boot = () => {
	document.querySelectorAll(".case-studies").forEach((section) => {
		observeElementInView(section, () => initCaseStudies(section));
	});
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
